import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Container = styled.form`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 420px;
  height: ${({ theme }) => theme.alturaControle.md};
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.md};
  background-color: ${({ theme }) => theme.cores.card};
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.cores.borderStrong};
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.cores.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.cores.foco};
  }

  ${media.mobile} {
    max-width: none;
    height: ${({ theme }) => theme.alturaControle.mobile};
  }
`;

export const Input = styled.input`
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0 12px;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.cores.ink};
  font-size: ${({ theme }) => theme.fonte.body};
  text-overflow: ellipsis;
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.cores.inkMuted};
  }

  ${media.mobile} {
    font-size: 16px;
  }
`;

export const Botao = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 100%;
  border: none;
  border-left: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: 0 ${({ theme }) => theme.raio.md} ${({ theme }) => theme.raio.md} 0;
  background: transparent;
  color: ${({ theme }) => theme.cores.inkSecondary};

  &:hover {
    background-color: ${({ theme }) => theme.cores.surface};
    color: ${({ theme }) => theme.cores.primary};
  }

  ${media.mobile} {
    width: 44px;
  }
`;
